export const formatDate = (input) => {
    let array = (input || '')
      .toString()
      .split('-');
    array.push(array.shift());
    return array.join('/') || null;
  }
